export default {
  // Informs billing information is loaded
  billingLoaded(state) {
    state.billingLoaded = true;
  },
  invoicesLoaded(state) {
    state.invoicesLoaded = true;
  },
  billingData(state, payload) {
    state.status = payload.status;
    state.accountLocked = payload.accountLocked;
    state.unbilledCharges = payload.unbilledCharges;
    state.taxability = payload.taxability;
    state.paymentMethod = payload.paymentMethod;
    state.nextBillingAt = payload.nextBillingAt;
    state.promotionalCredits = payload.promotionalCredits;
    state.billingPeriodUnit = payload.billingPeriodUnit;
    state.currencySymbol = payload.currencySymbol;
    state.currencyCode = payload.currencyCode;
    state.unpaidCharges = payload.unpaidCharges;
    state.billingAddress = payload.billingAddress;
    state.storedCard = payload.storedCard;
  },
  productData(state, payload) {
    state.products = payload;
  },
  updateBillingInformation(state, payload) {
    state.billingAddress = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      streetAddress: payload.streetAddress,
      city: payload.city,
      state: payload.state,
      zipcode: payload.zipcode,
      emailAddress: payload.emailAddress,
      billingPhone: payload.billingPhone,
    };
  },
  updateCard(state, payload) {
    state.storedCard = {
      status: payload.status,
      maskedNumber: payload.maskedNumber,
      cardType: payload.cardType,
      last4: payload.last4,
      expiryMonth: payload.expiryMonth,
      expiryYear: payload.expiryYear,
    };
    state.paymentMethod = "card";
  },
  deleteCard(state) {
    state.paymentMethod = null;
    state.storedCard = {};
    state.paymentMethod = "No payment method";
  },
  invoiceData(state, payload) {
    state.invoiceData = payload;
  },
};
